import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/items'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  item: {},
  items: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  item: state => state.item,
  items: state => state.items
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_ITEM = 'REQUEST_GET_ITEM'
const RECEIVE_GET_ITEM = 'RECEIVE_GET_ITEM'

const REQUEST_CREATE_ITEM = 'REQUEST_CREATE_ITEM'
const RECEIVE_CREATE_ITEM = 'RECEIVE_CREATE_ITEM'

const REQUEST_UPDATE_ITEM = 'REQUEST_UPDATE_ITEM'
const RECEIVE_UPDATE_ITEM = 'RECEIVE_UPDATE_ITEM'

const REQUEST_DELETE_ITEM = 'REQUEST_DELETE_ITEM'
const RECEIVE_DELETE_ITEM = 'RECEIVE_DELETE_ITEM'

const UPDATE_ITEM_PROPERTY = 'UPDATE_ITEM_PROPERTY'

const REQUEST_GET_ITEMS = 'REQUEST_GET_ITEMS'
const RECEIVE_GET_ITEMS = 'RECEIVE_GET_ITEMS'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getItems ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting items', { root: true })
    commit(REQUEST_GET_ITEMS)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receiveItems', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting items', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting items', { root: true })
        return Promise.reject(error)
      })
  },
  async getItem ({ commit, dispatch }, { id, includes = undefined }) {
    dispatch('wait/start', 'getting item', { root: true })
    commit(REQUEST_GET_ITEM, id)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.get(`${endpointConfig.url}/${id}`, config)
      .then((response) => {
        dispatch('receiveItem', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting item', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting item', { root: true })
        return Promise.reject(error)
      })
  },
  async createItem ({ commit, dispatch }, data) {
    dispatch('wait/start', 'creating item', { root: true })
    commit(REQUEST_CREATE_ITEM, data)
    return axios.post(`${endpointConfig.url}`, data, endpointConfig)
      .then((response) => {
        dispatch('receiveItem', [ response.data, 'CREATE' ])
        dispatch('wait/end', 'creating item', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'creating item', { root: true })
        return Promise.reject(error)
      })
  },
  async updateItem ({ commit, dispatch }, [ id, data ]) {
    dispatch('wait/start', 'updating item', { root: true })
    commit(REQUEST_UPDATE_ITEM, id)
    return axios.put(`${endpointConfig.url}/${id}`, data, endpointConfig)
      .then((response) => {
        dispatch('receiveItem', [ response.data, 'UPDATE' ])
        dispatch('wait/end', 'updating item', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'updating item', { root: true })
        return Promise.reject(error)
      })
  },
  async deleteItem ({ commit, dispatch }, id) {
    dispatch('wait/start', 'deleting item', { root: true })
    commit(REQUEST_DELETE_ITEM, id)
    return axios.delete(`${endpointConfig.url}/${id}`, endpointConfig)
      .then((response) => {
        commit(RECEIVE_DELETE_ITEM, response.data)
        dispatch('wait/end', 'deleting item', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'deleting item', { root: true })
        return Promise.reject(error)
      })
  },
  receiveItem ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_ITEM`, extract(json))
    return json.data
  },
  receiveItems ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_ITEMS`, extract(json))
    return json.data
  },
  updateItemProperty ({ commit, dispatch }, [ property, value ]) {
    commit(`UPDATE_ITEM_PROPERTY`, [ property, value ])
  }
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_ITEM] (state, id) {
  },
  [RECEIVE_GET_ITEM] (state, json) {
    state.item = json
  },
  [REQUEST_CREATE_ITEM] (state, json) {
  },
  [RECEIVE_CREATE_ITEM] (state, json) {
    state.item = json
  },
  [REQUEST_UPDATE_ITEM] (state, id) {
  },
  [RECEIVE_UPDATE_ITEM] (state, json) {
    state.item = json
  },
  [REQUEST_DELETE_ITEM] (state, id) {
  },
  [RECEIVE_DELETE_ITEM] (state, json) {
    state.item = {}
  },
  [UPDATE_ITEM_PROPERTY] (state, [ property, value ]) {
    state.item[property] = value
  },
  [REQUEST_GET_ITEMS] (state) {
  },
  [RECEIVE_GET_ITEMS] (state, json) {
    state.items = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
